import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SafeHtml, Title } from '@angular/platform-browser';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import {
  SelectItem,
  MessageService,
  ConfirmationService
} from 'primeng/primeng';
import { PatientService } from 'src/app/services/patient.service';
import { ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { PatientDataPassService } from 'src/app/services/patient-data-pass.service';
import {
  medicalHistoryApiData,
  Medication,
  Social_History_Data
} from '../../../models/history';
import {
  name_input,
  address,
  city,
  phoneNumber,
  zipCode,
  textareaBox,
  dose_input,
  number_input,
  medication_name_input,
  blockSpecialCharachters,
  IMAGE_PROFILE_ID_SUPPORTED_TYPES
} from 'src/app/constant/constant';
import { MedicalHistoryUiEditComponent } from '../../shared/medical-history-ui-edit/medical-history-ui-edit.component';
import { MedicalHistoryService } from 'src/app/services/medical-history.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MedicalReports } from '../../shared/patient-view/medical-reports/medical-reports.component';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { TraceClassDecorator } from '@sentry/angular';
import { health_passport_storage } from 'src/app/models/patient-profile';
import { consultation_status } from 'src/app/models/consultdoctors';
import { ProviderStateService } from 'src/app/services/provider-state.service';

export class MedicalTemplate {
  constructor() {
    this.medical_history_count = 0;
    this.docs = 0;
  }
  medical_history_count: number = 0;
  docs: number = 0;

  members = [
    { name: 'Mother', data: [] },
    { name: 'Father', data: [] },
    { name: 'Brother', data: [] },
    { name: 'Sister', data: [] }
  ];

  Document_data = [
    {
      id: 0,
      name: 'Primary Consultation Report',
      data: []
    },
    {
      id: 1,
      name: 'MRI',
      data: []
    },
    {
      id: 2,
      name: 'Blood Report',
      data: []
    },
    {
      id: 3,
      name: 'Ultrasound',
      data: []
    },
    {
      id: 4,
      name: 'X-Ray',
      data: []
    }
  ];
}

interface file_Obj {
  file_id: number;
  document_link: string;
  document_key: string;
  document_name: string;
  document_size: number;
  updated_at?: Date;
  formattedDocumentSize: string;
}
interface DocumentData {
  id: number;
  name: string;
  data: file_Obj[];
}

class IDForm {
  identification_type: string;
  identification: File;
  show_form = false;
  posting = false;
  has_id = false;
}

@Component({
  selector: 'app-upload-and-edit-documents',
  templateUrl: './upload-and-edit-documents.component.html',
  styleUrls: [
    './upload-and-edit-documents.component.css',
    '../../../../assets/css/custom-egd.css'
  ],
  providers: [MessageService, ConfirmationService]
})
@TraceClassDecorator()
export class UploadAndEditDocumentsComponent
  implements OnInit, AfterContentChecked, OnDestroy {
  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  readonly medication_name_input: RegExp = medication_name_input;
  readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
  private readonly image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
  // condition_edit_id: number;
  readonly acceptedAttachmentTypes = '.jpg,.jpeg,.png,.pdf,.doc,.docx,.dicom';

  @ViewChild(MedicalHistoryUiEditComponent)
  child: MedicalHistoryUiEditComponent;
  medicalHistoryApiData: medicalHistoryApiData =
    this.medicalHistoryService.init_medicalHistoryApiData();
  unique_id: SelectItem[] = [];
  slug: string = "";
  health_passport_data: health_passport_storage = new health_passport_storage();
  show_health_passport_bar: boolean = false;
  consultation_status: consultation_status;
  show_id_dropdown: boolean = false;
  uploadedFiles;
  showConsultationText: boolean = false;

  selectedMemberName = '';
  showTabs: boolean = false;
  selectMemeber: SelectItem = null;

  members_list: SelectItem[] = [];

  consultation_id_list: SelectItem[] = [];

  consultation_id: SelectItem = null;

  member = '';

  selectedTab: number = 0;

  confirmDialogVisible = false;

  MedicalReports: MedicalReports = new MedicalReports();
  guid = null;
  // year = new Date().getFullYear();
  // emptyHistory: boolean;
  // filteredConditions: any[];
  // height='50px';

  display: boolean = false;
  has_submitted_id = false;
  responsiveOptions;

  agree: boolean = false;

  socialHistory_data: SafeHtml = '';
  new_doc_name;
  displayBasic: boolean;

  displayCondition: Boolean = false;

  displayAllergy: Boolean = false;

  displayMedication: Boolean = false;

  id_form: IDForm = new IDForm();

  apiResult = new ApiResult(false);

  // medicalHistoryApiData_input: medicalHistoryApiData = this.medicalHistoryService.init_medicalHistoryApiData();
  // medicalHistoryApiData_output: medicalHistoryApiData = this.medicalHistoryService.init_medicalHistoryApiData();

  constructor(
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly patientservice: PatientService,
    private readonly messageService: MessageService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly patientData: PatientDataPassService,
    private readonly confirmation: ConfirmationService,
    private readonly medicalHistoryService: MedicalHistoryService,
    private readonly utilitiesService: UtilitiesService,
    private readonly providerstateService: ProviderStateService,
    private readonly cdr: ChangeDetectorRef
  ) {

    this.unique_id = [
      { label: 'Driving License', value: 'Driving License' },
      { label: 'Passport', value: 'Passport' },
      { label: 'Other Govt. ID', value: 'Other Govt. ID' }
    ];
  }
  ngAfterContentChecked(): void {
    try {
      this.cdRef.detectChanges();
    } catch (error) { }
  }
  // years = [];

  showDialog() {
    if (this.agree) {
      this.display = true;
    }
  }
  gotodashboard() {
    this.RouterNavigation('/patient/dashboard');
  }

  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
      { label: 'Upload Medical Details' }
    ]);
    //    debugger;
    this.guid = null;
    //   debugger;

    // for (let i = new Date().getFullYear(); i >= 1900; i--) {
    //     this.years.push({ name: i });
    // }
    this.SetTitle('Dashboard - Upload Medical Details');
    // this.getMemberList();
    // this.status = [
    //     { name: 'Active' },
    //     { name: 'Inactive' },
    //     { name: 'Cured' }
    // ];

    // this.medication_columns = [
    //     'Sr. No.',
    //     'Medications',
    //     'Dose',
    //     'Times per day',
    //     'Instructions'
    // ];

    // this.allergy_columns = [
    //     'Sr. No.',
    //     'Allergy',
    //     'Allergic Reaction'
    // ];

    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];



    // this.filteredConditions = this.autoConditions;

    await this.getMemberList();
    this.patientData.getID().subscribe((message) => {
      this.guid = message;
    });

    if (this.guid) {
      this.selectMemeber = this.members_list.filter(
        (member) => member.value === this.guid
      )[0];
      await this.onSelectMemeber(this.selectMemeber);

      this.selectedTab = 0;
    }
    await this.GetHistoryList();
  }

  async getHealthPassportStorage(patient_guid: string) {
    await this.patientservice
      .getHealthPassportStorage(patient_guid)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.show_health_passport_bar = true;
          this.health_passport_data = result.data.storageDetails;
        }
      })
      .catch((error: HttpErrorResponse) => { });
  }

  async fetchIDStatus(patient_guid: string): Promise<void> {
    await this.patientservice
      .fetchIDStatus(patient_guid)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.id_form.show_form = !Boolean(
            result.data.has_uploaded.toString() === 'true'
          );
          this.id_form.has_id = !this.id_form.show_form;
        }
      })
      .catch((error: HttpErrorResponse) => { });
  }
  onReject() { }

  uploadUniqueIDFiles(file: File[]) {
    if (this.image_types.includes(file[0].type.toLowerCase())) {
      if (file[0].size > 5033165) {
        this.id_form.identification = null;
      } else if (file[0].size < 5033165) {
        this.id_form.identification = file[0];
      }
    } else {
      this.id_form.identification = null;
    }
  }
  // onHide() {
  //     this.fileu = false;
  // }
  resetUnquieIDUpload() {
    this.id_form.identification = null;
  }

  onAgreeChange(Event: Event) {
    this.agree = Boolean(Event);
  }

  RouterNavigation(path: string) {
    this.router.navigate(['/' + this.slug + '/' + path]);
  }

  async GetHistoryList() {
    this.medicalHistoryApiData.selected_past_medical_history_data = [];
    await this.patientservice
      .GetHistoryDefaultList()
      .toPromise()
      .then((result) => {
        const family_history = result.data.family_history;
        const medical_history = result.data.medical_history;
        this.medicalHistoryApiData.other_data.family_history_options_data =
          family_history.map((e, i) => {
            let e_new: SelectItem = {
              label: e['history_name'],
              value: e['history_name']
            };
            return e_new;
          });
        this.medicalHistoryApiData.past_medical_history_data =
          medical_history.map((e, i) => ({
            id: e['id'],
            name: e['history_name'],
            selected: false
          }));


      })
      .catch((error: HttpErrorResponse) => { });
  }

  addDoc() {
    if (this.new_doc_name.length > 0) {
      this.Document_data.push({
        id: this.Document_data.length,
        name: this.new_doc_name,
        data: []
      });
      this.new_doc_name = '';
    }
  }

  async processTheData(ApiData: medicalHistoryApiData) {
    this.medicalHistoryApiData = ApiData;
    if (!this.medicalHistoryApiData.other_data.is_exist_current_medical_problem)
      await this.CreateConditions();
    else await this.UpdateMedicalConditions();
    await this.submitHistory();
    this.medicalHistoryApiData.other_data.empty_medical_history =
      this.medicalHistoryService.allMedicalSelectdCheck(
        this.medicalHistoryApiData.past_medical_history_data
      );
    await this.submitMedication_Allergies();
  }

  confirmDocumentDelete(
    event: Event,
    name: string,
    file_id: number,
    id: number,
    document_key: string
  ) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    this.confirmation.confirm({
      key: 'confirm-delete-document',
      message: 'Are you sure to delete the document ' + name + '?',
      accept: () => {
        this.DeleteDocument(document_key, id, file_id);
      }
    });
  }

  SetTitle(title: string) {
    this.titleService.setTitle(title);
  }

  showBasicDialog() {
    this.displayBasic = true;
  }

  showAddConditionDialog() {
    this.displayCondition = true;
  }
  showAddAllergyDialog() {
    this.displayAllergy = true;
  }
  showAddMedicationDialog() {
    this.displayMedication = true;
  }

  close() {
    this.displayCondition = false;
    this.displayAllergy = false;
    this.displayMedication = false;
  }

  async submitID(): Promise<void> {
    this.id_form.posting = true;
    const form: FormData = new FormData();
    form.set('patient_guid', this.selectMemeber.value.patient_guid);
    form.set('identification', this.id_form.identification);
    form.set('identification_type', this.id_form.identification_type);
    await this.patientservice
      .UpdateProfile(form)
      .toPromise()
      .then((result) => {
        this.has_submitted_id = result.success;
        if (result.success) {
          this.members_list.forEach((element) => {
            if (
              element.value.patient_guid ==
              this.selectMemeber.value.patient_guid
            ) {
              element.value.identification_type =
                this.id_form.identification_type;
              element.value.identification_url = result.data.identification_url;
              this.selectMemeber.value.identification_type =
                this.id_form.identification_type;
              this.selectMemeber.value.identification_url =
                result.data.identification_url;
            }
          });
          this.id_form.show_form = false;
          this.id_form.identification_type = null;
          this.id_form.identification = null;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: this.id_form.identification.name + ' is uploaded'
          });
        }
      })
      .catch((error: HttpErrorResponse) => { });
    this.id_form.posting = false;
  }

  async uploadFiles(Files: File[], id: number, uploadfileform) {
    for (let file of Files as File[]) {
      const form: FormData = new FormData();
      form.set('patient_guid', this.selectMemeber.value.patient_guid);
      form.set('file', file);
      form.set('folder_name', this.Document_data[id].name);
      form.set('document_name', file.name);
      form.set('document_size', file.size.toString());
      form.set('consultationId', this.consultation_id.value.consultation_id);

      await this.patientservice
        .UploadFiles(form)
        .toPromise()
        .then((result) => {
          if (!result.success)
            return this.messageService.add({
              severity: 'error',
              detail: result.error.message
            });
          this.Document_data[id].data.push({
            file_id: result.data.file_id,
            document_link: result.data.document_link,
            document_name: file.name,
            document_size: file.size,
            document_key: result.data.document_key,
            formattedDocumentSize:
              result.data.storageChange.formattedAdditionalSpace
          });
          this.health_passport_data.percentage = Number(
            (
              Number(this.health_passport_data.percentage) +
              Number(result.data.storageChange.percentageIncrease)
            ).toFixed(2)
          );
          this.health_passport_data.formattedStorageSpaceUsed =
            result.data.storageChange.formattedStorageSpaceUsed;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: file.name + ' is uploaded'
          });
        })
        .catch((error: HttpErrorResponse) => {
          return this.messageService.add({
            severity: 'error',
            detail:
              error.status == 500
                ? 'Something went wrong!'
                : error.error.message.toString()
          });
        });
    }
    uploadfileform.clear();
    this.cdr.detectChanges();
  }

  async DeleteDocument(document_key: string, id: number, file_id: number) {
    const data = {
      patient_guid: this.selectMemeber.value.patient_guid,
      document_key: document_key
    };
    await this.patientservice
      .DeleteFiles(data)
      .toPromise()
      .then(async (result) => {
        if (!result.success)
          return this.messageService.add({
            severity: 'error',
            detail: result.error.message
          });
        if (result.success) {
          let temp = [];
          for (let i = 0; i < this.Document_data[id].data.length; i++) {
            if (this.Document_data[id].data[i].file_id != file_id) {
              temp.push(this.Document_data[id].data[i]);
            }
          }
          this.Document_data[id].data = temp;
          this.health_passport_data.percentage = Number(
            (
              Number(this.health_passport_data.percentage) -
              Number(result.data.storageChange.percentageDecrease)
            ).toFixed(2)
          );

          this.health_passport_data.formattedStorageSpaceUsed =
            result.data.storageChange.formattedStorageSpaceUsed;
        }
      })
      .catch((error: HttpErrorResponse) => {
        return this.messageService.add({
          severity: 'error',
          detail:
            error.status == 500
              ? 'Something went wrong!'
              : error.error.message.toString()
        });
      });
  }

  async GetDocuments(consultation_id?: number) {
    let id = this.selectMemeber.value.patient_guid;
    this.MedicalReports.data.api_result.Posting = true;
    await this.patientservice
      .GetDocuments(id, { consultation_id })
      .toPromise()
      .then((result) => {
        let a: PromiseResult = result;
        if (result.success) {
          a.data = this.shallow_copy(result.data);
          let fileobj = this.shallow_copy(result.data);
          for (let curr = 0; curr < this.Document_data.length; curr++) {
            this.Document_data[curr].data = [];
            const name = this.Document_data[curr].name
              .replace(/ /g, '_')
              .toLowerCase();
            if (fileobj[name]) {
              this.Document_data[curr].data = fileobj[name];
              fileobj[name] = [];
              this.Document_data[curr].name = this.Document_data[curr].name
                .replace(/_/g, ' ')
                .toUpperCase();
            }
          }
          for (const key of Object.keys(fileobj)) {
            if (fileobj.hasOwnProperty(key)) {
              if (fileobj[key].length > 0) {
                this.Document_data.push({
                  id: this.Document_data.length,
                  name: key.replace(/_/g, ' ').toUpperCase(),
                  data: fileobj[key]
                });
              }
            }
          }
        } else {
          return this.messageService.add({
            severity: 'error',
            detail: result.error.message
          });
          a.data = {};
        }
        this.MedicalReports.data.api_result.PromiseResult = a;
        this.MedicalReports.data.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.MedicalReports.data.api_result.ServerError = error.error;
        this.MedicalReports.data.api_result.Posting = false;
        this.MedicalReports.data.api_result.PromiseResult.success = false;
        return this.messageService.add({
          severity: 'error',
          detail:
            error.status == 500
              ? 'Something went wrong!'
              : error.error.message.toString()
        });
      });
  }

  Document_data: DocumentData[] = [
    {
      id: 0,
      name: 'PRIMARY CONSULTATION REPORT',
      data: []
    },
    {
      id: 1,
      name: 'MRI',
      data: []
    },
    {
      id: 2,
      name: 'BLOOD REPORT',
      data: []
    },
    {
      id: 3,
      name: 'ULTRASOUND',
      data: []
    },
    {
      id: 4,
      name: 'XRAY',
      data: []
    },
    {
      id: 5,
      name: 'PRESCRIPTION',
      data: []
    }
  ];

  async getMemberList() {
    let temp: SelectItem[] = [];

    await this.patientservice
      .getMember(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result) => {
        for (let i = 0; i < result.data.patient.length; i++) {
          temp.push({
            label:
              ' ' +
              result.data.patient[i].first_name +
              ' ' +
              (result.data.patient[i].middle_name == null ? '' : result.data.patient[i].middle_name) +
              ' ' +
              result.data.patient[i].last_name +
              ' ',
            value: {
              patient_guid: result.data.patient[i].patient_guid,
              identification_url: result.data.patient[i].identification_url,
              identification_type: result.data.patient[i].identification_type
            }
          });
        }
      })
      .catch((error: HttpErrorResponse) => { });
    this.members_list = temp;
  }

  async GetConditions() {
    await this.patientservice
      .GetMedicalCondtions(this.selectMemeber.value.patient_guid)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.medicalHistoryApiData.currentMedicalProblems =
            result.data.current_medical_problems;
          this.medicalHistoryApiData.other_data.is_exist_current_medical_problem =
            true;
        } else {
          this.medicalHistoryApiData.currentMedicalProblems = '';
          this.medicalHistoryApiData.other_data.is_exist_current_medical_problem =
            false;
        }
      })
      .catch((error: HttpErrorResponse) => { });
  }

  async CreateConditions() {
    await this.patientservice
      .CreateMedicalCondtions(
        this.selectMemeber.value.patient_guid,
        this.medicalHistoryApiData.currentMedicalProblems
      )
      .toPromise()
      .then((result) => {
        if (result.success)
          this.medicalHistoryApiData.other_data.is_exist_current_medical_problem =
            true;
      })
      .catch((error: HttpErrorResponse) => { });
  }

  async UpdateMedicalConditions() {
    await this.patientservice
      .updateMedicalCondtions(
        this.selectMemeber.value.patient_guid,
        this.medicalHistoryApiData.currentMedicalProblems
      )
      .toPromise();
  }

  async GetMedicationsAllergies() {
    await this.patientservice
      .GetMedicationsAllergies(this.selectMemeber.value.patient_guid)
      .toPromise()
      .then((result) => {
        this.medicalHistoryApiData.allergies = [];
        this.medicalHistoryApiData.medications = [];
        if (result.success) {
          const allergies = result.data.allergies;
          const medications = result.data.medications;
          if (allergies != null && allergies.length > 0) {
            // const allergies = result.data.allergies;
            this.medicalHistoryApiData.allergies = allergies;
          } else {
            this.medicalHistoryApiData.allergies = [];
          }
          if (medications != null && medications.length > 0) {
            // const medications = result.data.medications;
            let temp: Medication[] = [];
            temp = medications;
            this.medicalHistoryApiData.medications = temp.map((e) => {
              let e_new = this.shallow_copy(e);
              e_new['instructions'] = !Boolean(e['instructions'])
                ? ''
                : e['instructions'];
              return e_new;
            });
          } else {
            this.medicalHistoryApiData.medications = [];
          }
        }
      })
      .catch((error: HttpErrorResponse) => { });
  }

  async submitMedication_Allergies() {
    const data = {
      allergies: this.medicalHistoryApiData.allergies,
      medications: this.medicalHistoryApiData.medications
    };

    await this.patientservice
      .updateMedications_Allergies(this.selectMemeber.value.patient_guid, data)
      .toPromise()
      .catch((error: HttpErrorResponse) => { });
  }

  shallow_copy(a) {
    return this.utilitiesService.shallow_copy(a);
  }

  async GetHistory() {
    await this.patientservice
      .GetMedicalHistory(this.selectMemeber.value.patient_guid)
      .toPromise()
      .then(async (result) => {
        // let template = new MedicalTemplate();
        if (result.success) {
          const family_history = result.data.family_history;
          const medical_history = result.data.past_medical_history_data;
          const socialHistory = result.data.social_history;
          const surgicalHistory = result.data.past_surgical_history_data;
          if (surgicalHistory != null && surgicalHistory.length > 0) {
            this.medicalHistoryApiData.past_surgical_history_data =
              surgicalHistory;
          } else {
            this.medicalHistoryApiData.past_surgical_history_data =
              this.medicalHistoryService.init_medicalHistoryApiData().past_surgical_history_data;
          }
          if (family_history != null && family_history.length > 0) {
            this.medicalHistoryApiData.family_history =
              this.medicalHistoryService.preprocess_familyhistory(
                family_history
              );
          } else {
            this.medicalHistoryApiData.family_history =
              this.medicalHistoryService.init_medicalHistoryApiData().family_history;
          }

          if (medical_history != null && medical_history.length > 0) {
            this.medicalHistoryApiData.selected_past_medical_history_data =
              medical_history.map((e) => {
                let e_new = this.shallow_copy(e);
                e_new['selected'] = true;
                return e_new;
              });
            this.medicalHistoryApiData.other_data.none_selected_medical_history =
              false;
            this.medicalHistoryApiData.past_medical_history_data =
              this.medicalHistoryService.preprocess_medicalhistory(
                this.medicalHistoryApiData.past_medical_history_data,
                this.medicalHistoryApiData.selected_past_medical_history_data
              );
          } else {
            // this.medicalHistoryApiData.past_medical_history_data = [];
            this.medicalHistoryApiData.selected_past_medical_history_data = [];
            this.medicalHistoryApiData.other_data.none_selected_medical_history =
              true;
          }

          if (socialHistory != null) {
            let a: Social_History_Data =
              this.medicalHistoryService.preprocess_socialhistory(
                socialHistory
              );
            this.socialHistory_data = a.social_history_data;
            this.medicalHistoryApiData.social_history = {
              smoking: a.smoking,
              alcohol: a.alcohol
            };
          } else {
            this.medicalHistoryApiData.social_history.smoking =
              this.medicalHistoryService.init_Smoking();
            this.medicalHistoryApiData.social_history.alcohol =
              this.medicalHistoryService.init_Alcohol();
          }
        } else {
          this.medicalHistoryApiData.family_history =
            this.medicalHistoryService.init_medicalHistoryApiData().family_history;
          await this.GetHistoryList();
          this.medicalHistoryApiData.past_surgical_history_data = '';
        }
      })
      .catch((error: HttpErrorResponse) => { });
  }

  async onSelectMemeber(member) {
    this.selectMemeber = member;
    this.selectedMemberName = this.selectMemeber.label;
    this.showTabs = false;
    this.selectedTab = 0;
    await this.getConsultationid(this.selectMemeber.value.patient_guid);
    this.medicalHistoryApiData.other_data.empty_medical_history =
      this.medicalHistoryService.allMedicalSelectdCheck(
        this.medicalHistoryApiData.past_medical_history_data
      );
  }

  async onSelectConsultationId() {
    this.showTabs = true;
    await this.GetDocuments(this.consultation_id.value.consultation_id);
    await this.fetchIDStatus(this.selectMemeber.value.patient_guid);
    await this.getHealthPassportStorage(this.selectMemeber.value.patient_guid);
    await this.GetConditions();
    await this.GetHistory();
    await this.GetMedicationsAllergies();
  }
  async getConsultationid(patient_guid: string) {
    let temp: SelectItem[] = [];

    await this.patientservice
      .getMyRequest(patient_guid, {
        consultation_status: [
          consultation_status.open,
          consultation_status.inprogress,
          consultation_status.scheduled
        ]
      })
      .toPromise()
      .then((result) => {
        for (let i = 0; i < result.data.length; i++) {
          let specialties = result.data[i].p_consultation_appointment.map(
            (appointment) => appointment.d_specialty_type.specialty_name
          );

          let label = `${result.data[i].consultation_request_number
            } - ${specialties.join(', ')}`;
          temp.push({
            label: label,
            value: {
              consultation_id: result.data[i].id
            }
          });
        }
        if (result.data == '') {
          this.showConsultationText = true;
          this.showTabs = false;
          this.show_id_dropdown = false;
        } else {
          this.show_id_dropdown = true;
          this.showConsultationText = false;
        }
      })
      .catch((error: HttpErrorResponse) => { });
    this.consultation_id_list = temp;
  }

  async submitHistory() {
    this.socialHistory_data = '';
    this.medicalHistoryApiData.selected_past_medical_history_data =
      this.medicalHistoryService.filterMedicalHistory(
        this.medicalHistoryApiData.past_medical_history_data
      );
    this.medicalHistoryApiData.selected_family_history =
      this.medicalHistoryService.filterFamilyHistory(
        this.medicalHistoryApiData.family_history
      );
    let a: Social_History_Data =
      this.medicalHistoryService.preprocess_socialhistory(
        this.shallow_copy(this.medicalHistoryApiData.social_history)
      );
    this.socialHistory_data = a.social_history_data;
    this.medicalHistoryApiData.social_history = {
      smoking: a.smoking,
      alcohol: a.alcohol
    };

    const data = {
      past_medical_history_data:
        this.medicalHistoryApiData.selected_past_medical_history_data,
      family_history: this.medicalHistoryApiData.selected_family_history,
      past_surgical_history_data:
        this.medicalHistoryApiData.past_surgical_history_data,
      social_history: this.medicalHistoryApiData.social_history,
      patient_guid: this.selectMemeber.value.patient_guid
    };
    await this.patientservice
      .updateMedicalHistory(data)
      .toPromise()
      .catch((error: HttpErrorResponse) => { });
  }

  async nextTab() {
    this.selectedTab = Math.min(this.selectedTab + 1, 3);
    if (this.selectedTab != 1) await this.child.saving_data();
    await this.onTabChange({ index: this.selectedTab });
    this.cdr.detectChanges();
  }

  async prevTab() {
    this.selectedTab = Math.max(this.selectedTab - 1, 0);
    if (this.selectedTab != 1) await this.child.saving_data();
    await this.onTabChange({ index: this.selectedTab });
    this.cdr.detectChanges();
  }

  async onTabChange(event) {
    let i: number = event.index;
    if (i == 3) {
      await this.GetDocuments(this.consultation_id.value.consultation_id);
    }
  }

  ngOnDestroy() {
    this.patientData.resetID();
  }
}
